import React, { createContext, useContext, useState, useCallback } from "react";
import { AuthDialog } from "@/components/AuthDialog";
import { Paywall } from "@/components/Paywall";

const ModalCtx = createContext(null);
export const useModals = () => useContext(ModalCtx);

export function ModalProvider({ children }) {
  const [auth, setAuth] = useState({ open: false, mode: "register", onSuccess: null, title: null });
  const [paywall, setPaywall] = useState({ open: false, trigger: "generic" });

  const openAuth = useCallback((opts = {}) => {
    setAuth({ open: true, mode: opts.mode || "register", onSuccess: opts.onSuccess || null, title: opts.title || null });
  }, []);
  const closeAuth = useCallback(() => setAuth((a) => ({ ...a, open: false })), []);

  const openPaywall = useCallback((trigger = "generic") => setPaywall({ open: true, trigger }), []);
  const closePaywall = useCallback(() => setPaywall((p) => ({ ...p, open: false })), []);

  return (
    <ModalCtx.Provider value={{ openAuth, closeAuth, openPaywall, closePaywall }}>
      {children}
      <AuthDialog
        open={auth.open}
        mode={auth.mode}
        title={auth.title}
        onClose={closeAuth}
        onSuccess={(u) => {
          closeAuth();
          if (auth.onSuccess) auth.onSuccess(u);
        }}
      />
      <Paywall open={paywall.open} trigger={paywall.trigger} onClose={closePaywall} />
    </ModalCtx.Provider>
  );
}
